import React, { useEffect, useState } from 'react';
import { getCurrentSeason, getSeasonInfo } from '../utils/seasonUtils';
import { useLocation } from 'react-router-dom';
import '../styles/seasonalThemes.css';

/**
 * Componente para aplicar el tema estacional a la aplicación
 * y mostrar un banner con mensaje estacional
 */
const SeasonalTheme = ({ showBanner = true }) => {
  const [season, setSeason] = useState(getCurrentSeason());
  const [seasonInfo, setSeasonInfo] = useState(getSeasonInfo());
  const location = useLocation();
  
  // Verificar si estamos en el panel de administrador
  const isAdminPanel = window.location.hostname.startsWith('admin.');
  
  // Verificar si estamos en la página de inicio
  const isLandingPage = location.pathname === '/';
  
  useEffect(() => {
    // Solo aplicar la clase estacional si NO estamos en el panel de administrador
    if (!isAdminPanel) {
      document.documentElement.classList.add(`season-${season}`);
      
      // Función de limpieza para cuando el componente se desmonte
      return () => {
        document.documentElement.classList.remove(`season-${season}`);
      };
    }
  }, [season, isAdminPanel]);
  
  // Si no se quiere mostrar el banner o estamos en el panel de administrador, no mostramos nada
  if (!showBanner || isAdminPanel) return null;
  
  return (
    <div className={`seasonal-banner ${isLandingPage ? 'landing-banner' : ''}`}>
      <div className="season-message">
        <span className="season-icon">{seasonInfo.icon}</span>
        <span className="season-text">{seasonInfo.message}</span>
      </div>
    </div>
  );
};

export default SeasonalTheme; 